/* eslint-disable */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// require('es6-promise/auto')
// require('es6-promise').polyfill()
import Es6Promise from 'es6-promise'
Es6Promise.polyfill()
var Promise = require('es6-promise').Promise;
import 'core-js'
import Vue from 'vue'
import PortalVue from 'portal-vue';
import App from './App'
import router from './router'

Vue.use(PortalVue)
Vue.config.productionTip = false

export const bus = new Vue()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js